/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './post-op-recovery.reducer';

export const PostOpRecoveryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const postOpRecoveryEntity = useAppSelector(state => state.postOpRecovery.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="postOpRecoveryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.postOpRecovery.detail.title">PostOpRecovery</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.id">Id</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.id}</dd>
          <dt>
            <span id="recievedAt">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.recievedAt">Recieved At</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.recievedAt}</dd>
          <dt>
            <span id="carePlan">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.carePlan">Care Plan</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.carePlan}</dd>
          <dt>
            <span id="careGiven">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.careGiven">Care Given</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.careGiven}</dd>
          <dt>
            <span id="dischargedAt">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.dischargedAt">Discharged At</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.dischargedAt}</dd>
          <dt>
            <span id="patientFirst">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.patientFirst">Patient First</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.patientFirst ? 'true' : 'false'}</dd>
          <dt>
            <span id="sideRailsUp">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.sideRailsUp">Side Rails Up</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.sideRailsUp ? 'true' : 'false'}</dd>
          <dt>
            <span id="checkMeds">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.checkMeds">Check Meds</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.checkMeds ? 'true' : 'false'}</dd>
          <dt>
            <span id="frequentAssessment">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.frequentAssessment">Frequent Assessment</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.frequentAssessment ? 'true' : 'false'}</dd>
          <dt>
            <span id="toiletAssist">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.toiletAssist">Toilet Assist</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.toiletAssist ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.active">Active</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.postOpRecovery.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{postOpRecoveryEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOpRecovery.surgery">Surgery</Translate>
          </dt>
          <dd>{postOpRecoveryEntity.surgery ? postOpRecoveryEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.postOpRecovery.nurse">Nurse</Translate>
          </dt>
          <dd>{postOpRecoveryEntity.nurse ? postOpRecoveryEntity.nurse.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/post-op-recovery" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/post-op-recovery/${postOpRecoveryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PostOpRecoveryDetail;
